// @flow
import React, { useState, Fragment, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import "./styles.css";
import * as toolsActions from "../../action-creators/tools-actions";
import Spinner from "../../components/spinner";
import classNames from "classnames";
import FAB from "../../components/fab";
import Modal from "../../components/modal";
import FileUpload from "../../components/file-upload";

type PropsType = {
    actions: { [string]: any=>void },
    isBusy: boolean,
    towns: ?Object,
    trashCollectionSites: ?Object,
    faqs: ?Object,
    supplyDistributionSites: ?Object,
    celebrations: ?Object,
    error: ?string,
    backupRestore: ?number
};


const MyScreen = ({ actions, isBusy, towns, backupRestore, faqs, trashCollectionSites, supplyDistributionSites, celebrations, error }: PropsType) => {

    const [modal, setModal] = useState();
    const [trashCollectionSiteData, setTrashCollectionSiteData] = useState();
    const [supplyDistributionSiteData, setSupplyDistributionSiteData] = useState();
    const [celebrationData, setCelebrationData] = useState();
    const [faqData, setFAQData] = useState();
    const [townData, setTownData] = useState();

    const openModal = (modalId) => () => {
        setModal(modalId);
    };

    const closeModal = () => {
        setModal();
    };

    const restoreTownData = () => {
        if (townData) {
            actions.restoreTownData(townData);
        } else {
            window.alert("invalid backup");
        }
        setModal();
    };

    const restoreTrashCollectionSiteData = () => {
        if (trashCollectionSiteData) {
            actions.restoreTrashCollectionSiteData(trashCollectionSiteData);
        } else {
            window.alert("invalid backup");
        }
        setModal();
    };

    const restoreSupplyDistributionSiteData = () => {
        if (supplyDistributionSiteData) {
            actions.restoreSupplyDistributionSiteData(supplyDistributionSiteData);
        } else {
            window.alert("invalid backup");
        }
        setModal();
    };

    const restoreCelebrationData = () => {
        if (celebrationData) {
            actions.restoreCelebrationsData(celebrationData);
        } else {
            window.alert("invalid backup");
        }
        setModal();
    };

    const restoreFAQData = () => {
        if (faqData) {
            actions.restoreFAQSData(faqData);
        } else {
            window.alert("invalid backup");
        }
        setModal();
    };


    useEffect(() => {
        if (error) {
            window.alert(error);
        }

    }, [error]);

    useEffect(() => {
        if (backupRestore) {
            window.alert("Restore Successful");
        }

    }, [backupRestore]);

    return (
        <Fragment>
            <div className={ "tools-screen" }>
                <div className={ "tools-screen--row" }>
                    <h3>Town Data</h3>
                    <div className={ "tools-screen--row--buttons" }>
                        <FAB
                            onClick={ actions.queryTowns }
                            icon={ "faRunning" }
                            label={ "Run Backup" }
                        />
                        <FAB
                            href={ `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(towns))}` }
                            download={ (towns === null) ? false : "towns.json" }
                            disabled={ towns === null }
                            icon={ "faFileDownload" }
                            label={ "Download Backup" }
                        />
                        <FAB
                            onClick={ openModal("towns") }
                            icon={ "faFileUpload" }
                            label={ "Restore Backup" }
                        />
                    </div>

                </div>
                <div className={ "tools-screen--row" }>
                    <h3>Trash Collection Sites</h3>
                    <div className={ "tools-screen--row--buttons" }>
                        <FAB
                            onClick={ actions.queryTrashCollectionlSites }
                            icon={ "faRunning" }
                            label={ "Run Backup" }
                        />
                        <FAB
                            href={ `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(trashCollectionSites))}` }
                            download={ (trashCollectionSites === null) ? false : "trash-Collection-sites.json" }
                            disabled={ trashCollectionSites === null }
                            icon={ "faFileDownload" }
                            label={ "Download Backup" }
                        />
                        <FAB
                            onClick={ openModal("trashCollectionSites") }
                            icon={ "faFileUpload" }
                            label={ "Restore Backup" }
                        />
                    </div>
                </div>
                <div className={ "tools-screen--row" }>
                    <h3>Supply Distribution Sites</h3>
                    <div className={ "tools-screen--row--buttons" }>
                        <FAB
                            onClick={ actions.querySupplyDistributionSites }
                            icon={ "faRunning" }
                            label={ "Run Backup" }
                        />
                        <FAB
                            href={ `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(supplyDistributionSites))}` }
                            download={ (supplyDistributionSites === null) ? false : "supply-distribution-sites.json" }
                            disabled={ supplyDistributionSites === null }
                            icon={ "faFileDownload" }
                            label={ "Download Backup" }
                        />
                        <FAB
                            onClick={ openModal("supplyDistributionSites") }
                            icon={ "faFileUpload" }
                            label={ "Restore Backup" }
                        />
                    </div>

                </div>
                <div className={ "tools-screen--row" }>
                    <h3>Celebrations</h3>
                    <div className={ "tools-screen--row--buttons" }>
                        <FAB
                            onClick={ actions.queryCelebrations }
                            icon={ "faRunning" }
                            label={ "Run Backup" }
                        />
                        <FAB
                            href={ `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(celebrations))}` }
                            download={ (celebrations === null) ? false : "celebrations.json" }
                            disabled={ celebrations === null }
                            icon={ "faFileDownload" }
                            label={ "Download Backup" }
                        />
                        <FAB
                            onClick={ openModal("celebrations") }
                            icon={ "faFileUpload" }
                            label={ "Restore Backup" }
                        />
                    </div>

                </div>
                <div className={ "tools-screen--row" }>
                    <h3>FAQ Data</h3>
                    <div className={ "tools-screen--row--buttons" }>
                        <FAB
                            onClick={ actions.queryFAQs }
                            icon={ "faRunning" }
                            label={ "Run Backup" }
                        />
                        <FAB
                            href={ `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(faqs))}` }
                            download={ (faqs === null) ? false : "faqs.json" }
                            disabled={ faqs === null }
                            icon={ "faFileDownload" }
                            label={ "Download Backup" }
                        />
                        <FAB
                            onClick={ openModal("faqs") }
                            icon={ "faFileUpload" }
                            label={ "Restore Backup" }
                        />
                    </div>
                </div>
                <div className={ classNames("tools-screen--is-busy", { active: isBusy }) }>
                    <Spinner containerStyle={ { position: "absolute" } }/>
                </div>
            </div>
            <Modal
                isOpen={ modal === "towns" }
                onClose={ closeModal }
            >
                <div className={ "tools-screen--modal" }>
                    <h2 className={ "tools-screen--modal-header" }>Upload Town Data Backup File</h2>
                    <FileUpload
                        className={ "tools-screen--towns-modal" }
                        formId={ "townsBackup" }
                        name={ "files[]" }
                        onChange={
                            files => {
                                if ((files || []).length > 0) {
                                    const file = files[0];
                                    const reader = new FileReader();

                                    // Closure to capture the file information.
                                    reader.onload = (e => {
                                        setTownData(e.target.result);
                                    });
                                    reader.readAsText(file);
                                }
                            }
                        }/>
                    <div className={ "tools-screen--data-preview" }>
                        <pre>
                            {townData && JSON.stringify(JSON.parse(townData), undefined, 2)}
                        </pre>
                    </div>
                    <footer className={ "tools-screen--modal-footer" }>
                        <button className={ "secondary" } disabled={ !townData } onClick={ restoreTownData }>Restore Backup</button>
                        <button disabled={ !townData } onClick={ () => {
                            setTownData();
                        } }>Clear
                        </button>

                    </footer>
                </div>
            </Modal>
            <Modal
                isOpen={ modal === "supplyDistributionSites" }
                onClose={ closeModal }
            >
                <div className={ "tools-screen--modal" }>
                    <h2 className={ "tools-screen--modal-header" }>Upload Supply Distribution Site Data Backup File</h2>
                    <FileUpload
                        className={ "tools-screen--supplyDistributionSites-modal" }
                        id={ "supplyDistributionSitesBackup" }
                        name={ "files[]" }
                        onChange={
                            files => {
                                if ((files || []).length > 0) {
                                    const file = files[0];
                                    const reader = new FileReader();

                                    // Closure to capture the file information.
                                    reader.onload = (e => {
                                        setSupplyDistributionSiteData(e.target.result);
                                    });
                                    reader.readAsText(file);
                                }
                            }
                        }/>
                    <div className={ "tools-screen--data-preview" }>
                        <pre>
                            {supplyDistributionSiteData && JSON.stringify(JSON.parse(supplyDistributionSiteData), undefined, 2)}
                        </pre>
                    </div>
                    <footer className={ "tools-screen--modal-footer" }>
                        <button className={ "secondary" } disabled={ !supplyDistributionSiteData } onClick={ restoreSupplyDistributionSiteData }>Restore Backup</button>
                        <button disabled={ !supplyDistributionSiteData } onClick={ () => {
                            setSupplyDistributionSiteData();
                        } }>Clear
                        </button>
                    </footer>
                </div>
            </Modal>
            <Modal
                isOpen={ modal === "trashCollectionSites" }
                onClose={ closeModal }
            >
                <div className={ "tools-screen--modal" }>
                    <h2 className={ "tools-screen--modal-header" }>Upload Trash Collection Sites Backup File</h2>
                    <FileUpload
                        className={ "tools-screen--towns-modal" }
                        id={ "townsBackup" }
                        name={ "files[]" }
                        onChange={
                            files => {
                                if ((files || []).length > 0) {
                                    const file = files[0];
                                    const reader = new FileReader();

                                    // Closure to capture the file information.
                                    reader.onload = (e => {
                                        setTrashCollectionSiteData(e.target.result);
                                    });
                                    reader.readAsText(file);
                                }
                            }
                        }/>
                    <div className={ "tools-screen--data-preview" }>
                        <pre>
                            {trashCollectionSiteData && JSON.stringify(JSON.parse(trashCollectionSiteData), undefined, 2)}
                        </pre>
                    </div>
                    <footer className={ "tools-screen--modal-footer" }>
                        <button className={ "secondary" } disabled={ !trashCollectionSiteData } onClick={ restoreTrashCollectionSiteData }>Restore Backup</button>
                        <button disabled={ !trashCollectionSiteData } onClick={ () => {
                            setTrashCollectionSiteData();
                        } }>
                            Clear
                        </button>

                    </footer>
                </div>
            </Modal>
            <Modal
                isOpen={ modal === "celebrations" }
                onClose={ closeModal }
            >
                <div className={ "tools-screen--modal" }>
                    <h2 className={ "tools-screen--modal-header" }>Upload Celebrations Data Backup File</h2>
                    <FileUpload
                        className={ "tools-screen--celebrations-modal" }
                        id={ "celebrationsBackup" }
                        name={ "files[]" }
                        onChange={
                            files => {
                                if ((files || []).length > 0) {
                                    const file = files[0];
                                    const reader = new FileReader();
                                    reader.onload = (e => {
                                        setCelebrationData(e.target.result);
                                    });
                                    reader.readAsText(file);
                                }
                            }
                        }/>
                    <div className={ "tools-screen--data-preview" }>
                        <pre>
                            {celebrationData && JSON.stringify(JSON.parse(celebrationData), undefined, 2)}
                        </pre>
                    </div>
                    <footer className={ "tools-screen--modal-footer" }>
                        <button className={ "secondary" } disabled={ !celebrationData } onClick={ restoreCelebrationData }>Restore Backup</button>
                        <button disabled={ !celebrationData } onClick={ () => {
                            setCelebrationData();
                        } }>Clear
                        </button>

                    </footer>
                </div>
            </Modal>
            <Modal
                isOpen={ modal === "faqs" }
                onClose={ closeModal }
            >
                <div className={ "tools-screen--modal" }>
                    <h2 className={ "tools-screen--modal-header" }>Upload FAQ Data Backup File</h2>
                    <FileUpload
                        className={ "tools-screen--faqs-modal" }
                        id={ "faqBackup" }
                        name={ "files[]" }
                        onChange={
                            files => {
                                if ((files || []).length > 0) {
                                    const file = files[0];
                                    const reader = new FileReader();
                                    reader.onload = (e => {
                                        setFAQData(e.target.result);
                                    });
                                    reader.readAsText(file);
                                }
                            }
                        }/>
                    <div className={ "tools-screen--data-preview" }>
                        <pre>
                            {faqData && JSON.stringify(JSON.parse(faqData), undefined, 2)}
                        </pre>
                    </div>
                    <footer className={ "tools-screen--modal-footer" }>
                        <button className={ "secondary" } disabled={ !faqData } onClick={ restoreFAQData }>Restore Backup</button>
                        <button disabled={ !faqData } onClick={ () => {
                            setFAQData();
                        } }>Clear
                        </button>
                    </footer>
                </div>
            </Modal>
        </Fragment>
    );

};
const mapStateToProps = (state: Object): Object => state.tools;

const mapDispatchToProps = (dispatch): Object => ({
    actions: bindActionCreators(toolsActions, dispatch)
});

export const ToolsScreen = connect(mapStateToProps, mapDispatchToProps)(MyScreen);
